<template>
  <v-container class="py-0">
    <v-timeline dense clipped>
      <v-slide-x-transition
        group
      >
        <v-timeline-item
          v-for="event in recipient.timeline"
          :key="event.id"
          class="mb-3"
          fill-dot
          color="primary"
          :icon="event.icon"
          small
        >
          <v-layout justify-space-between class="px-0">
            <v-flex xs7 v-text="$t(event.event)"></v-flex>
            <v-flex xs5 text-xs-right >

              <p class="caption ma-0 grey--text" v-text="$d(event.insertedAt.toDate(), 'long')"></p>
            </v-flex>
          </v-layout>
        </v-timeline-item>
      </v-slide-x-transition>

    </v-timeline>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      input: null,
      nonce: 0
    }),

    computed: {
      ...mapGetters({
        recipient: 'recipients/record'
      })
    },
    beforeMount () {
      this.$store.dispatch('recipients/getTimeline', this.$route.params.recipientId)
    },
    beforeDestroy () {
      this.$store.dispatch('recipients/unset')
    }
  }
</script>
